/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import ShapeEnum, { getShapeToCount } from 'shared/enum/shape';

import Now from 'shared/query/current.time';
import Url from 'shared/client/url';
import Galaxy from 'shared/query/galaxy';
import Navigation from 'shared/client/navigation';

import * as Coords from 'shared/geo/coords';


export default new Client([ Navigation, Galaxy, Url, Now ], class
{
  constructor (navigation, galaxy, url, now)
  {
    this.now = now;

    this.galaxy = galaxy;
    this.navigation = navigation;

    this.source = navigation.getCurrent();
    this.target = navigation.getRawTarget();

    this.args = url.getRoute().getArgs();
  }


  onDone ()
  {
    const shape = this.navigation.getBehaviorShape();

    this.galaxy.createUnit(this.source, this.target, this.args.type, shape);
  }


  getError ()
  {
    if (this.args.type == null)
    {
      return 'No unit type found';
    }

    const currency = this.galaxy.getCurrentUser().getCurrency(this.now);

    if (currency < this.getUnitConstants().getConstructionCost())
    {
      return 'Not enough currency to produce unit';
    }

    /*if (!this.source.getZone().getEnergy().canSpend(this.getUnitConstants().getEnergy()))
    {
      return 'Not enough energy to produce unit';
    }*/

    if (this.source.equals(this.target))
    {
      return 'Unit cannot attack zone it occupies.';
    }

    const distance  = Coords.getDistance(this.source.getCoords(), this.target.getCoords());

    if (distance < this.getUnitConstants().getTargetMinRange())
    {
      return 'Target zone is too close. Please select more distant target.';
    }

    if (distance > this.getUnitConstants().getTargetMaxRange())
    {
      return 'Target zone is out of range. Please select a closer target.';
    }

    if (!this.target.getZone())
    {
      return 'Cannot attack empty space.';
    }

    return null;
  }


  getInitial ()
  {
    if (this.args.type === '')
    {
      return 'Select unit type';
    }

    if (this.target == null)
    {
      return 'Select target zone';
    }

    return null;
  }


  getUnitConstants ()
  {
    return this.galaxy.getConstants().getUnit(this.args.type);
  }


});
